import React, { Fragment, useState } from "react";
import PropTypes from "prop-types";
import { Icon, Picture } from "../../../atoms";
import { VideoPlayer } from "../../../molecules";
import styled from "styled-components";

const Video = ({
  className,
  url,
  audioDescription,
  theme,
  onClick,
  placeholder,
  ...props
}) => {
  const [onPlay, setPlay] = useState(false);

  const onPlayVideo = () => {
    setPlay(true);
  };

  const onEndVideo = () => {
    setPlay(false);
  };

  return (
    <div className={className}>
      {onPlay ? (
        <Fragment>
          <button
            className="audio-description"
            onClick={onClick}
            aria-label="Audio description"
            /*
            aria-label={intl.formatMessage({
              id: "app.header.video.button.audioDescription",
              defaultMessage: "Audio description"
            })}
            */
          >
            <Icon
              name={
                audioDescription
                  ? theme.icons.audio_description_active
                  : theme.icons.audio_description
              }
              size="medium"
              color={theme.components.header.video.adButton.iconColor}
            />
          </button>
          <VideoPlayer
            url={url}
            paddingTop="0"
            marginBottom="0"
            marginTop="0"
            height="100%"
            onEnded={onEndVideo}
            playing={onPlay}
            config={{
              youtube: {
                playerVars: {
                  showinfo: 0,
                  iv_load_policy: 3,
                  modestbranding: 1,
                  rel: 0,
                  autoplay: 0,
                  fs: 1
                }
              }
            }}
            {...props}
          />
        </Fragment>
      ) : (
        <Fragment>
          <button
            className="play-video"
            onClick={onPlayVideo}
            aria-label="Watch Vídeo"
            /*
            aria-label={intl.formatMessage({
              id: "app.header.video.button.play",
              defaultMessage: "Watch Vídeo"
            })}
             */
          >
            <Icon
              name={theme.icons.youtube_play}
              size="xxxLarge"
              color={theme.components.header.video.imagePlaceholder.iconColor}
            />
          </button>

          <Picture src={placeholder} alt="imagem" height="100%" />
        </Fragment>
      )}
    </div>
  );
};

Video.propTypes = {
  className: PropTypes.string,
  url: PropTypes.string,
  audioDescription: PropTypes.bool,
  placeholder: PropTypes.string,
  theme: PropTypes.object,
  onClick: PropTypes.func
};

const VideoWithStyles = styled(Video)`
  position: relative;
  height: 100%;
  max-height: ${props => props.theme.components.header.maxHeight};
  background-color: ${props => props.theme.components.header.video.bgColor};

  button.play-video {
    background-color: rgba(0, 0, 0, 0.2);
    border: none;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    cursor: pointer;
  }

  button.audio-description {
    position: absolute;
    right: 16px;
    top: 70px;
    background-color: transparent;
    border: none;
    height: 36px;
    width: 36px;
    z-index: 1;
    cursor: pointer;
    opacity: 0;
    -moz-transition: opacity 0.1s cubic-bezier(0.4, 0, 1, 1);
    -webkit-transition: opacity 0.1s cubic-bezier(0.4, 0, 1, 1);
    transition: opacity 0.1s cubic-bezier(0.4, 0, 1, 1);

    &:hover {
      :after {
        content: attr(aria-label);
        position: absolute;
        background-color: ${props =>
          props.theme.components.header.video.adButton.toolTipBgColor};
        color: ${props =>
          props.theme.components.header.video.adButton.toolTipColor};
        font-weight: 500;
        font-size: 13px;
        width: auto;
        bottom: -39px;
        right: 0;
        padding: 6px 8px;
        border-radius: 2px;
        white-space: nowrap;
        text-align: center;
        text-shadow: 0 0 2px rgba(0, 0, 0, 0.5);
      }
    }
  }

  &:hover {
    button.audio-description {
      opacity: 1;
    }
  }

  // Medium devices (tablets, less than 992px)
  @media (max-width: 991px) {
    button.audio-description {
      opacity: 1;
    }
  }
`;

export default VideoWithStyles;
